// extracted by mini-css-extract-plugin
export default {"image":"Image_image__DcSp1","standard":"Image_standard__Cn44V","medium":"Image_medium__vNBc8","desktop":"Image_desktop__PgyFy","hero":"Image_hero__bptaq"};